<template>
	<div class="improt_wrapper" v-if="isShow">
		<el-dialog :show-close="false" :modal="false" :close-on-click-modal="false" :title="$t('m.Import')" v-dialogDrag
			:visible.sync="isShow" width="35%">
			<div class="line_gradual" />
			<div class="btn_wrapper">
				<div class="dow_btn">
          <el-button plain size='small' type='primary' @click='exportModel'>{{ $t('m.TemplateDow') }}</el-button>
				</div>
				<div class="file-upload">
					<div class="file-upload-text">{{ $t('m.ClickUpload') }}</div>
					<input name="modelFile" class="file-upload-input" id="modelFile" ref="fileWrapper" @change="setFileName($event)"
						type="file">
				</div>
				<span class="file_name" v-if="isFileName">{{ fileName }}</span>
			</div>

			<el-row style="margin-top: 10px">
				<el-col :span="24" style="color: red;"> 1、{{tipInfo}}</el-col>
			</el-row>
			<span slot="footer" class="dialog-footer">
				<el-button @click="cancelImp" type="primary" plain>{{ $t('m.cancel') }}</el-button>
				<el-button type="primary" plain @click="sureImp($event)">{{ $t('m.Save') }}</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
export default {
	name: 'ImportComponent',
	props: {
		//数据库信息实体
		parentEntity: {
			type: Object,
			default: () => { }
		},
		isShow: {
			type: Boolean,
			default: false
		},
		tempUrl: {
			type: String,
			default: ''
		},
		assetname: {
			type: String,
			default: ''
		},
		assetdataid: {
			type: String,
			default: ''
		},
		uploadUrl: {
			type: String,
			default: ''
		},
		downFileName: {
			type: String,
			default: ''
		},
		isFileName: {
			type: Boolean,
			default: true
		},
		faceParamData: {
			type: Object,
			default: () => { }
		}
	},
	data () {
		return {
			fileName: '未选择文件',
			fileObj: null,
			clickCol: false,
      tipInfo: '点击模板下载，按模板填写完数据后点击选择文件进行上传'
		}
	},
  computed: {
    language () {
      return this.$store.state.language
    }
  },
  watch: {
    language() {
      if (this.language === 'en-US') {
        this.fileName = 'Unselected file'
        this.tipInfo = 'Click the template to download, fill in the data according to the template, and then upload'
      }
    }
  },
	methods: {
		setFileName (eve) {
			this.file = eve.target.files[0];
			this.fileName = eve.target.files[0].name;
		},
		closeDialog () {
			this.$emit('closeDialog', this.isShow)
		},
		// 模板下载
		exportModel () {
			debugger
			let that = this;
			// 读取localStorage中的单据id和faceid
			let paramObj = {};
			if (that.faceParamData !== null && that.faceParamData !== '' && that.faceParamData !== undefined) {
				paramObj = that.faceParamData;
			}
			if (that.assetname !== null && that.assetname !== '' && that.assetname !== undefined) {
				paramObj.assetname = that.assetname;
			}
			if (this.tempUrl != '') {
				this.$ajax({
					url: this.tempUrl, // 请求的 url 地址
					method: 'post',
					data: paramObj,
					responseType: 'blob'
				}).then((res) => {
					const link = document.createElement('a');
					let blob = new Blob([res.data], { type: 'application/vnd.ms-excel' });
					link.style.display = 'none';
					link.href = URL.createObjectURL(blob);
					let num = '';
					for (let i = 0; i < 10; i++) {
						num += Math.ceil(Math.random() * 10);
					}
					link.setAttribute('download', `${this.downFileName}.xlsx`);
					this.closeDialog()
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
				});
			} else {
        this.$notify.warning({ position: 'bottom-right', title: '提示', message: '暂无模板' });
      }
		},
		// 文件上传
		sureImp () {
			debugger
			let that = this;
			if (!that.clickCol) {
				that.clickCol = true;
				setTimeout(() => {
					that.clickCol = false
				}, 2000)
				debugger
				this.fileObj = document.getElementById('modelFile').files[0];
				if (!this.fileObj) {
					this.$notify.warning({ position: 'bottom-right', title: '提示', message: '文件为空,请选择文件进行导入' });
          if (this.language === 'en-US') {
            this.fileName = 'Unselected file'
            this.tipInfo = 'Click the template to download, fill in the data according to the template, and then upload'
          } else {
            this.fileName = '未选择文件'
          }
					return false;
				} else if (this.uploadUrl != '') {
					this.fileName = this.fileObj.name
					let formData = new FormData();
					if (that.billid !== '' && that.billid !== undefined) {
						formData.append('billid', this.billid)
					}
					if (that.faceid !== '' && that.faceid !== undefined) {
						formData.append('faceid', this.faceid)
					}
					if (that.assetname !== null && that.assetname !== '' && that.assetname !== undefined) {
						formData.append('assetname', this.assetname)
					}
					if (that.assetdataid !== null && that.assetdataid !== '' && that.assetdataid !== undefined) {
						formData.append('assetdataid', this.assetdataid)

					}
					if (that.parentEntity !== null && that.parentEntity !== {} && that.parentEntity !== undefined) {
						formData.append("mainengine", this.parentEntity.mainengine);
						formData.append("drivername", this.parentEntity.drivername);
						formData.append("basetype", this.parentEntity.basetype);
						formData.append("databankname", this.parentEntity.databankname);
						formData.append("serverport", this.parentEntity.serverport);
						formData.append("username", this.parentEntity.username);
						formData.append("pwd", this.parentEntity.pwd);
					}
					formData.append("creater", this.GLOBAL.currUser.jobid);
					formData.append("updater", this.GLOBAL.currUser.jobid);
					formData.append('file', this.file);
					this.$ajax
						.post(this.uploadUrl, formData)
						.then(function (response) {
							if (response.data.code == 200) {
								that.$notify.success({ position: 'bottom-right', title: '提示', message: '上传成功' });
								that.fileName = '未选择文件'
								that.$refs.fileWrapper.value = ''
								that.closeDialog()
							} else {
								that.$notify.warning({ position: 'bottom-right', title: '提示', message: response.data.msg });
								that.fileName = '未选择文件'
								that.$refs.fileWrapper.value = ''
								that.closeDialog()
							}

						})
						.catch(function (error) {
							that.$notify.error({ position: 'bottom-right', title: '提示', message: '上传失败!' })
							that.fileName = '未选择文件'
							that.$refs.fileWrapper.value = ''

							that.closeDialog()
						});
				} else {
					that.$notify.error('上传失败!');
					that.fileName = '未选择文件'
					that.$refs.fileWrapper.value = ''

				}
			}
		},
		// 取消上传
		cancelImp () {
			this.isShow = false;
			this.fileName = '未选择文件'
			this.closeDialog()
		}
	}
}
</script>

<style lang="less" scoped>
.improt_wrapper {
	z-index: 9999999999 !important;

	.btn_wrapper {
		display: flex;

		.file_name {
			display: inline-block;
			height: 32px;
			line-height: 32px;
			margin-left: 20px;
			color: #777;
		}
	}

	.file-upload {
		width: 80px;
		height: 32px;
		position: relative;
		overflow: hidden;
		border: 1px solid #b3d8ff;
		display: inline-block;
		border-radius: 4px;
		font-size: 12px;
		color: #048ef2;
		text-align: center;
		line-height: 30px;
		margin-left: 20px;
		background-color: #ecf5ff;

		&:hover {
			background-color: #048ef2;
			color: #fff;
		}

		.file-upload-input {
			// background-color: transparent;
			position: absolute;
			width: 999px;
			height: 999px;
			top: -10px;
			right: -10px;
			cursor: pointer;
		}
	}
}
</style>
